import {writable} from 'svelte/store';
import '@/streams/auth';

export const appVersion$ = writable('');
export const appPlatform$ = writable('');
